import React from "react";
import { useParams } from "react-router-dom";
import { useData } from "../../../../../components/SiteMap/contexts/DataContext";
import SiteMapHazardRoute from "../../../../../components/SiteMap/routes/HazardRoute";

const SiteMapHazardPage = () => {
  const { hazardId } = useParams();
  const { hazardMarkers } = useData();

  const hazard = hazardMarkers.find(
    (hazard) => hazardId && hazard.id === parseInt(hazardId),
  );

  return (
    <>
      <SiteMapHazardRoute hazard={hazard} />
    </>
  );
};

export default SiteMapHazardPage;
